import { Routes } from '@angular/router';
import {Permissions} from '../permissions/permissions/permissions'
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';

export const permissionsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => Permissions,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Permissões`;
    }
  },
];
